import { IMaskDirective } from 'vue-imask';

export default {
	'imask': IMaskDirective
};